export const SET_STALL_APPLICATION_DETAILS_STATE =
  "SET_RACING_SECRETARY_STALL_APPLICATION_DETAILS_STATE";
export const SET_UNSAVED_CHANGES_POPUP_STATE =
  "SET_RACING_SECRETARY_STALL_APPLICATION_UNSAVED_CHANGES_POPUP_STATE";

export type TAction =
  | TRacingSecretaryStallApplicationState
  | TStallApplicationUnsavedChangesPopupState;

type TRacingSecretaryStallApplicationState = ReturnType<
  typeof setRacingSecretaryStallApplicationState
>;
type TStallApplicationUnsavedChangesPopupState = ReturnType<
  typeof setStallApplicationUnsavedChangesPopupState
>;

export const setRacingSecretaryStallApplicationState = (
  stallApplicationDetailsState: boolean
) =>
  ({
    type: SET_STALL_APPLICATION_DETAILS_STATE,
    stallApplicationDetailsState
  } as const);

export const setStallApplicationUnsavedChangesPopupState = (
  unsavedChangesPopupState: boolean
) =>
  ({
    type: SET_UNSAVED_CHANGES_POPUP_STATE,
    unsavedChangesPopupState
  } as const);
